import { Fragment, useEffect } from "react";
import {
	Box,
	Divider,
	Typography,
	Container,
	IconButton,
	Tooltip,
	TextField,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/Auth/AuthContext.jsx";
import { useCart } from "../../context/Cart/CartContext.jsx";

function MyData() {
	const { userData } = useAuth();
	const { cart } = useCart();
	const navigate = useNavigate();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Fragment>
			<Container>
				<Box display="flex" alignItems="center" minHeight="56px">
					<Box>
						<Tooltip title="Volver">
							<IconButton
								size="large"
								aria-label="volver"
								aria-controls="volver-carrito"
								aria-haspopup="false"
								color="inherit"
								onClick={() => navigate(-1)}
							>
								<ArrowBackIosIcon />
							</IconButton>
						</Tooltip>
					</Box>
					<Typography
						variant="h5"
						display="flex"
						justifyContent="center"
						alignItems="center"
						flexGrow={1}
					>
						Mis Datos
					</Typography>
					<Box>
						<Tooltip title="Carrito">
							<Link to="/cart">
								<IconButton
									size="large"
									aria-label="carrito"
									aria-controls="logo-carrito"
									aria-haspopup="false"
									color="inherit"
								>
									{cart?.length > 0 ? (
										<ShoppingBagIcon color="secondary" />
									) : (
										<ShoppingBagOutlinedIcon color="secondary" />
									)}
								</IconButton>
							</Link>
						</Tooltip>
					</Box>
				</Box>
			</Container>
			<Divider />
			<Container>
				<Box className="boxAddressShippingContainer" my={1} pt={2}>
					<Typography className="titleFirstRow" sx={{ fontWeight: "600" }}>
						Datos personales
					</Typography>
				</Box>
				<Divider />
				<Box
					component="form"
					sx={{
						"& .MuiTextField-root": { m: 1, width: "25ch" },
						display: "flex",
						flexDirection: "column",
						justifyContent: "space-around",
						alignItems: "center",
						input: {
							background: "#f8f9fa",
						},
					}}
					noValidate
					autoComplete="off"
					style={{ marginBottom: "20px", marginTop: "10px" }}
				>
					<TextField
						style={{ width: "95%" }}
						inputProps={{ style: { textTransform: "capitalize" } }}
						disabled
						id="filled-disabled"
						label="Nombre"
						defaultValue={userData.userName}
						variant="filled"
					/>
					{/* <TextField
						style={{ width: "95%" }}
						inputProps={{ style: { textTransform: "capitalize" } }}
						disabled
						id="filled-disabled"
						label="Empresa"
						defaultValue={userData.clientBusinessName}
						variant="filled"
					/> */}
					<TextField
						style={{ width: "95%" }}
						disabled
						id="filled-disabled"
						label="Teléfono"
						defaultValue={userData.clientPhone}
						variant="filled"
					/>
					<TextField
						style={{ width: "95%" }}
						disabled
						id="filled-disabled"
						label="Email"
						defaultValue={userData.userEmail}
						variant="filled"
					/>
					<TextField
						style={{ width: "95%" }}
						disabled
						id="filled-disabled"
						label={userData.clientDocType}
						defaultValue={userData.clientDocNumber}
						variant="filled"
					/>
					<TextField
						style={{ width: "95%" }}
						inputProps={{ style: { textTransform: "capitalize" } }}
						disabled
						id="filled-disabled"
						label="Dirección"
						defaultValue={userData.clientAddress}
						variant="filled"
					/>
					{/* <TextField
						style={{ width: "95%" }}
						disabled
						id="filled-disabled"
						label="Número"
						defaultValue={userData.addressNumber}
						variant="filled"
					/> */}
					<TextField
						style={{ width: "95%" }}
						disabled
						id="filled-disabled"
						label="Piso"
						defaultValue={userData.clientFloor}
						variant="filled"
					/>
					<TextField
						style={{ width: "95%" }}
						inputProps={{ style: { textTransform: "capitalize" } }}
						disabled
						id="filled-disabled"
						label="Departamento"
						defaultValue={userData.clientDoor}
						variant="filled"
					/>
					<TextField
						style={{ width: "95%" }}
						inputProps={{ style: { textTransform: "capitalize" } }}
						disabled
						id="filled-disabled"
						label="Ciudad"
						defaultValue={userData.clientCity}
						variant="filled"
					/>
					<TextField
						style={{ width: "95%" }}
						inputProps={{ style: { textTransform: "capitalize" } }}
						disabled
						id="filled-disabled"
						label="Provincia"
						defaultValue={userData.state || "Provincia"}
						variant="filled"
					/>
					<TextField
						style={{ width: "95%" }}
						disabled
						id="filled-disabled"
						label="Código Postal"
						defaultValue={userData.clientZipCode}
						variant="filled"
					/>
				</Box>
			</Container>
		</Fragment>
	);
}

export default MyData;
